import type { LogEvent } from 'pino';
import type { Logger, LoggerOptions } from '@zg-rentals/logger-base';
import { tryTask } from '@zg-rentals/stdlib/task';
import { ThrottledBatchWriter } from '@zg-rentals/stdlib/async';
import { createLogger } from '@zg-rentals/logger-base';
import { isbot } from 'isbot';

export default function getBrowserLogger({ logPath, ...options }: LoggerOptions = {}): Logger {
  options.level ??= 'info';

  const bw = new ThrottledBatchWriter(
    (batch: Array<LogEvent>) =>
      tryTask('browser logger flush', async () => {
        if (logPath && typeof window !== 'undefined' && !isbot(window.navigator.userAgent)) {
          const body = JSON.stringify(batch);

          if (navigator.sendBeacon) {
            navigator.sendBeacon(logPath, new Blob([body], { type: 'application/json' }));
          } else {
            await fetch(logPath, {
              body,
              method: 'POST',
              keepalive: true,
              headers: { 'content-type': 'application/json' },
            });
          }
        }
      }),
    2000,
  );

  options.browser ??= {};
  options.browser.transmit ??= {
    send: (_, logEvent) => {
      if (logEvent.level.value >= logger.levelVal) {
        bw.write(logEvent);
      }
    },
  };

  const logger = createLogger(options);

  return logger;
}
